import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-text-section-title',
  templateUrl: './text-section-title.component.html',
  styleUrls: ['./text-section-title.component.scss']
})
export class TextSectionTitleComponent implements OnInit {

  @Input()
  text: {
    title: string;
    subtitle: string;
  }

  constructor() { }

  ngOnInit() {
  }

}